<dx-select-box #selectBox
               [dataSource]="agentAuthenticationModes"
               [value]="selectedItem"
               displayExpr="name"
               valueExpr="id"
               [disabled]="loading"
               (selectedItemChange)="onSelectedItemChange($event)">
</dx-select-box>
